import { npsModalActionTypes } from './Constants';

export function toggleNPSModal(data) {
	return {
		type: npsModalActionTypes.TOGGLE_NPS_MODAL,
		payload: { data },
	};
}

export function submitNPSModal(data, requestId) {
	return {
		type: npsModalActionTypes.SUBMIT_NPS_MODAL,
		payload: { data, requestId },
	};
}

export function submitNPSModalSuccess(data) {
	return {
		type: npsModalActionTypes.SUBMIT_NPS_MODAL_SUCCESS,
		payload: { data },
	};
}

export function submitNPSModalError() {
	return {
		type: npsModalActionTypes.SUBMIT_NPS_MODAL_ERROR,
	};
}

export function clearState() {
	return {
		type: npsModalActionTypes.CLEAR_NPS_MODAL_STATE,
	};
}
